<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        class="mt-5"
        height="auto"
        @submit="updatePointReturn({type: 'return_points_after_coupon_exp',
         item: returnPoint,})"
    >

        <h4 class="secondary--text" v-text="translations.info[lang]"></h4>
        <v-radio-group class="mt-3 pt-0" hide-details v-model="returnPoint">
            <v-radio color="secondary" value="true">
                <template v-slot:label>
                    <h4
                        class="subtitle-2 secondary--text"
                        v-text="translations.yes[lang]"
                        
                    ></h4>
                </template>
            </v-radio>
            <v-radio color="secondary" value="false">
                <template v-slot:label >
                    <h4
                        class="subtitle-2 secondary--text"
                        v-text="translations.no[lang]"
                         
                    ></h4>
                </template>
            </v-radio>
        </v-radio-group>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/pointsReturn";
import { mapState,mapGetters, mapMutations, mapActions } from "vuex";
export default {
    name: "PointsReturn",

    mixins: [translations],
    data (){
        return {
        }
    },
   
    
    computed: {
        lang() {
            return this.$route.params.lang;
        },

        returnPoint: {
            get(){
                 return this.$store.state.loyaltyPanel.businessProfile.returnPoint;
            },
            set(val){
                this.setReturnPoint(val);
            }
        }
        
    },
    methods:{
        ...mapMutations("loyaltyPanel/businessProfile", ["setReturnPoint"]),
        ...mapActions("loyaltyPanel/businessProfile", [
            "updatePointReturn"
        ]),
    }
    
};
</script>
